import React from 'react';
import Status from 'components/status';
import Collection from './Collection';
import { stripTags } from 'utils/string';

const query = {
  // Note: name is deprecated but older clients may use it
  sort: 'title asc, name asc',
};

export const tabs = {
  default: {
    label: 'All pages',
  },
  published: {
    label: 'Published',
    query: {
      published: true,
    },
  },
  draft: {
    label: 'Draft',
    query: {
      published: { $ne: true },
    },
  },
};

const filters = {
  date_created: {
    label: 'Created',
    operators: ['after', 'before'],
    type: 'date',
  },
  published: {
    label: 'Status',
    options: [
      { value: 'true', label: 'Published' },
      { value: 'false', label: 'Unpublished' },
    ],
    func(query) {
      switch (query) {
        case 'true':
          return { published: true };

        case 'false':
          return { published: false };

        default:
          break;
      }
    },
    desc(query) {
      switch (query) {
        case 'true':
          return 'Published';

        case 'false':
          return 'Unpublished';

        default:
          break;
      }
    },
  },
};

const fields = {
  title: {
    label: 'Page title',
    default: true,
    sort: false,
    func({ title, name }) {
      // Note: name is deprecated but older clients may use it
      return title || name;
    },
  },
  slug: {
    label: 'Slug',
  },
  status: {
    label: 'Status',
    func({ published }) {
      return (
        <Status type={published ? 'positive' : 'muted'}>
          {published ? 'Published' : 'Draft'}
        </Status>
      );
    },
  },
  content: {
    label: 'Content',
    sort: false,
    func({ content }) {
      return stripTags(content);
    },
  },
  updated: {
    label: 'Updated',
    type: 'date',
    func({ date_created, date_updated }) {
      return date_updated || date_created;
    },
  },
};

const headerActions = [{ label: 'New page', link: '/content/pages/new' }];

export default class ContentPages extends React.Component {
  render() {
    return (
      <Collection
        {...this.props}
        title="Pages"
        uri="/content/pages"
        model="content/pages"
        emptyDescription="Manage pages published in your storefront."
        tabs={tabs}
        filters={filters}
        fields={fields}
        headerActions={headerActions}
        query={query}
      />
    );
  }
}
